<template>
  <div class="pr_msg">
    <div class="pr_msg_box" v-for="(item, index) in specification.paramsObject" :key="index">
      <p class="pr_msg_title">{{ index }}</p>
      <div class="pr_msg_data">
        <p v-for="(meItem, meIndex) in item" :key="meIndex">
          {{ meItem.name }}
          <span v-if="meItem.unit">（{{ meItem.unit }}）</span>
          : {{ meItem.value }}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props:{
    specification:Object,
  },
  data() {
    return {};
  },
};
</script>

<style lang="less" scoped>
.pr_msg {
  padding: 10px 0px;
  .pr_msg_box {
    margin-bottom: 20px;
    border-bottom: 1px solid #F3F3F3;
    .pr_msg_title {
      font-size: 16px;
      font-weight: bold;
      color: #2d50a1;
      padding-bottom: 10px;
      border-bottom: 1px solid #2d50a1;
      margin-bottom: 20px;
    }
    .pr_msg_data {
      display: grid;
      grid-template-columns: 25% 25% 25% 25%;
      margin: 0 15px;
      p {
        margin-bottom: 20px;
        font-size: 14px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/product/components/productMessage.vue